<template>
  <div class="tusd-wrap wrap-bg">
    <div class="page-title"><i class="back-btn" @click="goBack"></i>设置</div>
    <div class="separator"></div>
    <div class="setting-header">
    	<cube-upload
				class="header-wrap"
				ref="uploadFile"
			  :max="1"
			  :auto="false"
			  @files-added="filesAdded">
			  <div class="clearfix">
			    <cube-upload-btn :multiple="false">
			      <div class="upload-btn" :style="{'background-image':'url('+(headerImg?headerImg :'/images/header.png')+')'}"></div>
			    </cube-upload-btn>
			  </div>
			</cube-upload><br />
			<span class="upload-title">修改头像</span>
    </div>
	<!-- <div class="account-wrap setting-info">
    	<div class="wrap-item">
          <span class="item-label">接单开始时间</span>
		  <cube-select
			v-model="ServiceTimeStart"
			placeholder="0-24"
			@change="ServiceTimeEndChange"
			:options="options">
			</cube-select>
        </div>
		<div class="wrap-item">
          <span class="item-label">接单结束时间</span>
		  <cube-select
			v-model="ServiceTimeEnd"
			placeholder="0-24"
			@change="ServiceTimeEndChange"
			:options="options">
			</cube-select>
        </div>
    </div> -->
    <div class="separator"></div>
    <div class="account-wrap setting-info">
    	<!-- <div class="wrap-item" @click="goEdit">
    		<span class="item-label">昵称： </span>
    		<span class="unit unit-icon">{{setting.nickName}}&nbsp;</span>
    	</div> -->
    	<div class="tusd-btn" @click="save">确认修改</div>
	 	<div class="tusd-btn tusd-btn-danger" @click="logout">退出登录</div>
    </div>
  </div>
</template>

<script>
import api from "@/assets/api";
import message from '@/utils/message'
export default {
  name: 'setting',
  data(){
  	return {
		hasChange:false,
		headerImg:"",
  		params:{},
		ServiceTimeStart:null,
		ServiceTimeEnd:null,
		options:[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24]
  	}
  },
  methods:{
  	goBack(){
  		this.$router.push({name:this.params.back})
  	},
  	goEdit(){
  		let name = 'editIpt'
  		this.$store.commit('storeParams',{
  			name:name,
  			back:'setting',
  			title:'昵称',
  			prop:'nickName',
  			value:this.setting.nickName
  		})
  		this.$router.push({name:name})
  	},
  filesAdded(files) {
      let hasIgnore = false;
      const limitSize = 2 * 1024* 1024;
      // 最大5M
      const maxSize = 5 * 1024 * 1024;
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        // 如果选择的图片大小最大限制（这里为5M）则弹出提示
        if (file.size > maxSize) {
          file.ignore = true;
          hasIgnore = true;
          break;
        }
        // 如果选择的图片大小大于1M则进行图片压缩处理（Base64）
        if (file.size > limitSize) {
          this.compressPic(file);
        } else {
		  let reads = new FileReader();
          reads.readAsDataURL(file);
		  let that = this;
          reads.onload = function(e) {
			var bdata = this.result;
			file.base64=bdata;
			that.headerImg=bdata
			that.hasChange=true;
		  };
		}
      }
      hasIgnore &&this.$message.popup("图片最大支持5M",1000);
    },
    // 图片压缩方法
    compressPic(file) {
      let reads = new FileReader();
      reads.readAsDataURL(file);
      // 注意这里this作用域的问题
	  let that = this;
      reads.onload = function(e) {
        var bdata = this.result;
        // 这里quality的范围是（0-1）
        var quality=0.1;
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        var img = new Image();
        img.src = bdata;
        img.onload = function() {
          var width = img.width;
          canvas.width = width;
          canvas.height = width * (img.height / img.width);
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
		  let data = canvas.toDataURL("image/jpeg", quality);
		  file.base64=data
		  that.headerImg=bdata
		  that.hasChange=true;
		};
      };
	},
  	save(){
  		// if(!this.hasChange){
		// 	this.$message.popup("修改头像成功",1000);
  		// 	return false
		// }
		if(!this.ServiceTimeStart){
			this.$message.popup("请选择开始时间",1000);
			return false
		}
		if(!this.ServiceTimeEnd){
			this.$message.popup("请选择结束时间",1000);
			return false
		}
		if(Number(this.ServiceTimeEnd) < Number(this.ServiceTimeStart)){
			this.$message.popup("请选择正确的结束时间",1000);
			return false
		}
		var data={
			"key":this.compressPic(this.headerImg),
			"ServiceTimeEnd":this.ServiceTimeEnd,
			"ServiceTimeStart":this.ServiceTimeStart,
		}
		// 提交后台去修改
		api.changeHeaderImg(data).then((res)=>{
			//修改缓存中的图片的地址
			this.$store.commit("setHeaderImgUrl",res.data.headerImgPath);
			this.$message.popup("修改成功",1000);
			this.refreshUserInfoApi()
		});
  	},
  	logout(){
  		this.$router.push({name:'login'})
  	},
	  ServiceTimeEndChange(){
		
		if(this.ServiceTimeEnd && this.ServiceTimeStart){
			if(Number(this.ServiceTimeEnd) < Number(this.ServiceTimeStart)){
				this.$message.popup("请选择正确的结束时间",1000);
			}
		}
	  },
	  refreshUserInfoApi(){
		this.$api.refreshUserInfo().then(res => {
			this.$message.popup(res.msg, 1000);
			this.$store.commit("storeOnlyUserInfo", res.data);
		})
	  }
  },
  created(){
	this.params = this.$store.state.routerStore.setting
  	// this.headerImg =this.$store.state.userInfo.HeadImageUrl+"?t="+(+new Date());
  	this.headerImg =this.$store.state.userInfo.HeadImageUrl;
	this.ServiceTimeStart = this.$store.state.userInfo.ServiceTimeStart
	this.ServiceTimeEnd = this.$store.state.userInfo.ServiceTimeEnd
  }
}
</script>

<style lang="less" scoped>
 .cube-upload-btn{
	 position: inherit;
 }
	.setting-header{
		padding:20px 0px 24px;
		text-align: center;
		.header-wrap{
			display: inline-block;
			margin-bottom:12px;
			.upload-btn{
				width: 80px;
				height: 80px;
				background: url(../assets/images/header.png) center center no-repeat;
				background-size: contain;
				border:1px solid #3c4468;
				border-radius:50%;
			}
		}
		.upload-title{
			color:#d9e3fd;
			font-size:15px!important;
		}
	}
	.setting-info{
		padding:14px 26px;
		.wrap-item{
			margin-bottom: 60px;
		}
	}
	.account-wrap .wrap-item{
		margin-bottom: 10px;
		.item-label{
			width: 90px;
		}
		.cube-select{
			width: calc(100% - 90px);
			text-align: center;
		}
	} 
</style>